// Generated by ReScript, PLEASE EDIT WITH CARE

import * as City from "../../domain/types/vehicle-specific/City.bs.js";
import * as List from "../../../../../node_modules/rescript/lib/es6/list.js";
import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as CityConfig from "../../domain/store/CityConfig.bs.js";
import * as ContentTypes from "../../../../common/types/ContentTypes.bs.js";
import * as ListUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ListUtils.bs.js";
import * as TrackLiveTripConfig from "../../domain/store/TrackLiveTripConfig.bs.js";
import * as TrackLiveTripHelper from "../../helper/TrackLiveTripHelper.bs.js";

function getDiscountAmount(discount) {
  if (typeof discount === "number") {
    return "0";
  } else {
    return String(discount._0.discountAmount);
  }
}

function getNumber(rides) {
  if (rides > 1) {
    return String(rides) + " trips ";
  } else {
    return "trip ";
  }
}

function getRidesText(discount) {
  if (typeof discount === "number") {
    return "trip";
  } else {
    return getNumber(discount._0.discountRides);
  }
}

function getCouponType(discount) {
  if (typeof discount === "number") {
    return "";
  } else if (discount.TAG === /* Referral */0) {
    return "by using referral code ";
  } else {
    return "by using coupon code ";
  }
}

function getCouponCode(discount) {
  if (typeof discount === "number") {
    return "";
  } else {
    return discount._0.discountCode;
  }
}

function getReferralCondition(discount) {
  if (typeof discount === "number" || discount.TAG !== /* Referral */0) {
    return "";
  } else {
    return " during registration";
  }
}

function getVM(marketingDetail) {
  var discount = marketingDetail.discount;
  return {
          savingsMarketingContent: {
            title: "1000+ businesses ",
            subtitle: marketingDetail.savingAmount.toString(),
            text: {
              hd: "have saved over ",
              tl: {
                hd: " crores with us",
                tl: /* [] */0
              }
            }
          },
          downloadLinkContent: {
            title: "Download Porter",
            subtitle: marketingDetail.downloadLink,
            text: /* [] */0
          },
          marketingTitle: "Why Us?",
          discountMarketingContent: discount !== undefined ? ({
                title: "Get upto total ",
                subtitle: "INR " + (getDiscountAmount(discount) + " off "),
                text: {
                  hd: "on first ",
                  tl: {
                    hd: getRidesText(discount),
                    tl: {
                      hd: getCouponType(discount),
                      tl: {
                        hd: getCouponCode(discount),
                        tl: {
                          hd: getReferralCondition(discount),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              }) : undefined,
          etaMarketingContent: {
            title: String(marketingDetail.averageEta / 60 | 0) + " mins",
            subtitle: "Less than " + (String(marketingDetail.averageEta / 60 | 0) + " mins waiting time"),
            text: /* [] */0
          },
          priceMarketingContent: {
            title: "25%",
            subtitle: "cheaper than market",
            text: /* [] */0
          },
          partnerMarketingContent: {
            title: String(marketingDetail.registeredPartners) + "+",
            subtitle: "Drivers registered with us",
            text: /* [] */0
          },
          bookingTimeMarketingContent: {
            title: String(marketingDetail.averageBookingTime) + " seconds",
            subtitle: "Average booking time",
            text: /* [] */0
          }
        };
}

var tiffin_data = {
  TAG: /* LabelledImgWithDesc */6,
  _0: {
    src_path: ContentTypes.createAssetPath(TrackLiveTripConfig.nature_of_goods_tiffin_img),
    text: ContentTypes.createTitle(TrackLiveTripConfig.nature_of_goods_tiffin_title),
    desc: TrackLiveTripConfig.nature_of_goods_tiffin_desc,
    class_name: "tiffin"
  }
};

var kirana_store_data = {
  TAG: /* LabelledImgWithDesc */6,
  _0: {
    src_path: ContentTypes.createAssetPath(TrackLiveTripConfig.nature_of_goods_kirana_store_img),
    text: ContentTypes.createTitle(TrackLiveTripConfig.nature_of_goods_kirana_store_title),
    desc: TrackLiveTripConfig.nature_of_goods_kirana_store_desc,
    class_name: "kirana"
  }
};

var furniture_data = {
  TAG: /* LabelledImgWithDesc */6,
  _0: {
    src_path: ContentTypes.createAssetPath(TrackLiveTripConfig.nature_of_goods_furniture_img),
    text: ContentTypes.createTitle(TrackLiveTripConfig.nature_of_goods_furniture_title),
    desc: TrackLiveTripConfig.nature_of_goods_furniture_desc,
    class_name: "furniture"
  }
};

var home_decor_data = {
  TAG: /* LabelledImgWithDesc */6,
  _0: {
    src_path: ContentTypes.createAssetPath(TrackLiveTripConfig.nature_of_goods_home_decor_img),
    text: ContentTypes.createTitle(TrackLiveTripConfig.nature_of_goods_home_decor_title),
    desc: TrackLiveTripConfig.nature_of_goods_home_decor_desc,
    class_name: "home-decor"
  }
};

var fruits_vegetables_data = {
  TAG: /* LabelledImgWithDesc */6,
  _0: {
    src_path: ContentTypes.createAssetPath(TrackLiveTripConfig.nature_of_goods_fruits_vegetables_img),
    text: ContentTypes.createTitle(TrackLiveTripConfig.nature_of_goods_fruits_vegetables_title),
    desc: TrackLiveTripConfig.nature_of_goods_fruits_vegetables_desc,
    class_name: "fruits-vegetables"
  }
};

var commercial_equipments_data = {
  TAG: /* LabelledImgWithDesc */6,
  _0: {
    src_path: ContentTypes.createAssetPath(TrackLiveTripConfig.nature_of_goods_commercial_equipments_img),
    text: ContentTypes.createTitle(TrackLiveTripConfig.nature_of_goods_commercial_equipments_title),
    desc: TrackLiveTripConfig.nature_of_goods_commercial_equipments_desc,
    class_name: "commercials"
  }
};

var chemicals_data = {
  TAG: /* LabelledImgWithDesc */6,
  _0: {
    src_path: ContentTypes.createAssetPath(TrackLiveTripConfig.nature_of_goods_chemicals_img),
    text: ContentTypes.createTitle(TrackLiveTripConfig.nature_of_goods_chemicals_title),
    desc: TrackLiveTripConfig.nature_of_goods_chemicals_desc,
    class_name: "chemicals"
  }
};

var parcel_data = {
  TAG: /* LabelledImgWithDesc */6,
  _0: {
    src_path: ContentTypes.createAssetPath(TrackLiveTripConfig.nature_of_goods_parcel_img),
    text: ContentTypes.createTitle(TrackLiveTripConfig.nature_of_goods_parcel_title),
    desc: TrackLiveTripConfig.nature_of_goods_parcel_desc,
    class_name: "parcel"
  }
};

function getVehicleGoodsData(vehicle) {
  switch (vehicle) {
    case /* TwoWheeler */0 :
        return {
                hd: tiffin_data,
                tl: /* [] */0
              };
    case /* Pickup8ft1Ton */4 :
    case /* Pickup8ftOpen */6 :
        return {
                hd: commercial_equipments_data,
                tl: /* [] */0
              };
    case /* Tata407 */11 :
    case /* Tata407_14ft */12 :
        return {
                hd: chemicals_data,
                tl: /* [] */0
              };
    case /* Eeco */13 :
        return {
                hd: parcel_data,
                tl: /* [] */0
              };
    case /* PickupDostSuperAce8ft */2 :
    case /* TataAce */7 :
    case /* AceHelper */9 :
    case /* SuperAce8ft */10 :
    case /* TataAceClosed */16 :
        return {
                hd: furniture_data,
                tl: /* [] */0
              };
    case /* ThreeWheeler */1 :
    case /* ThreeWheelerHelper */17 :
        return {
                hd: fruits_vegetables_data,
                tl: /* [] */0
              };
    case /* Pickup8ft */3 :
    case /* Pickup8ft1Dot3Ton */5 :
    case /* TataAceOpen */8 :
    case /* ChampionHelper */14 :
    case /* Champion */15 :
    case /* ThreeWheelerMini */18 :
    case /* PorterHire */19 :
    case /* Rental */20 :
    case /* AceHelperPlusOneHelper */21 :
    case /* Canter3Tonne */22 :
    case /* Pickup1Tonne */23 :
        return /* [] */0;
    
  }
}

function getVehicleGoods(vehicle) {
  switch (vehicle) {
    case /* TwoWheeler */0 :
        return tiffin_data;
    case /* Pickup8ft1Ton */4 :
    case /* Pickup8ftOpen */6 :
        return commercial_equipments_data;
    case /* Tata407 */11 :
    case /* Tata407_14ft */12 :
        return chemicals_data;
    case /* Eeco */13 :
        return parcel_data;
    case /* PickupDostSuperAce8ft */2 :
    case /* TataAce */7 :
    case /* AceHelper */9 :
    case /* SuperAce8ft */10 :
    case /* TataAceClosed */16 :
        return furniture_data;
    case /* ThreeWheeler */1 :
    case /* ThreeWheelerHelper */17 :
        return fruits_vegetables_data;
    case /* Pickup8ft */3 :
    case /* Pickup8ft1Dot3Ton */5 :
    case /* TataAceOpen */8 :
    case /* ChampionHelper */14 :
    case /* Champion */15 :
    case /* ThreeWheelerMini */18 :
    case /* PorterHire */19 :
    case /* Rental */20 :
    case /* AceHelperPlusOneHelper */21 :
    case /* Canter3Tonne */22 :
    case /* Pickup1Tonne */23 :
        return ;
    
  }
}

function getUsecasesList(vehicle_list) {
  return List.fold_left((function (acc, vehicle) {
                var use_case = getVehicleGoods(vehicle.vehicle_type);
                if (use_case !== undefined && !List.exists((function (a) {
                          return a === use_case;
                        }), acc)) {
                  return List.append(acc, {
                              hd: use_case,
                              tl: /* [] */0
                            });
                } else {
                  return acc;
                }
              }), /* [] */0, vehicle_list);
}

function getAvailableVehiclesInfo(vehicle_info) {
  return List.map((function (vehicle) {
                return {
                        icon: vehicle.icon,
                        vehicle_type: vehicle.name,
                        display_name: vehicle.display_name,
                        use_cases: getVehicleGoods(vehicle.name)
                      };
              }), vehicle_info);
}

function scrollToElement(ele) {
  return ele.scrollIntoView({
              behavior: "smooth",
              block: "end",
              inline: "nearest"
            });
}

function publishGAEvents(action, label) {
  return TrackLiveTripHelper.publishEvent(TrackLiveTripConfig.ga_title_track_live_trip, action, undefined, label !== "" ? label : undefined, undefined);
}

function splitArray(input_array, range) {
  var value = input_array.length;
  if (value <= range) {
    return {
            hd: $$Array.sub(input_array, 0, input_array.length),
            tl: /* [] */0
          };
  } else if (value > range) {
    return {
            hd: $$Array.sub(input_array, 0, range),
            tl: splitArray($$Array.sub(input_array, range, input_array.length - range | 0), range)
          };
  } else {
    return {
            hd: [],
            tl: /* [] */0
          };
  }
}

function getModalApperanceTime(param) {
  return 10000;
}

var modal_hiding_cities_1 = {
  hd: CityConfig.bangalore,
  tl: {
    hd: CityConfig.delhi,
    tl: {
      hd: CityConfig.delhi_NCR,
      tl: {
        hd: CityConfig.surat,
        tl: /* [] */0
      }
    }
  }
};

var modal_hiding_cities = {
  hd: CityConfig.pune,
  tl: modal_hiding_cities_1
};

function hideAppDownloadModal(geo_region_id) {
  return ListUtils$Catalyst.find(modal_hiding_cities, (function (value) {
                return value === City.geoRegionIdToCity(geo_region_id);
              })) !== undefined;
}

export {
  getDiscountAmount ,
  getNumber ,
  getRidesText ,
  getCouponType ,
  getCouponCode ,
  getReferralCondition ,
  getVM ,
  tiffin_data ,
  kirana_store_data ,
  furniture_data ,
  home_decor_data ,
  fruits_vegetables_data ,
  commercial_equipments_data ,
  chemicals_data ,
  parcel_data ,
  getVehicleGoodsData ,
  getVehicleGoods ,
  getUsecasesList ,
  getAvailableVehiclesInfo ,
  scrollToElement ,
  publishGAEvents ,
  splitArray ,
  getModalApperanceTime ,
  modal_hiding_cities ,
  hideAppDownloadModal ,
  
}
/* tiffin_data Not a pure module */
